import React from "react";
import "assets/css/safexpay-web.css";
import "./PaymentMethods.css";

class PaymentMethods extends React.Component {
  render() {
    return (
      <>
        <section className="dv-PaymentMethods mt-0 pt-5 pb-5 mb-5">
          <h2
            className="section-heading font-w6"
            data-aos="zoom-in-up"
            data-aos-duration="1000"
          >
            Unlimited Payment Methods
          </h2>
          <div className="container">
            <div className="row" data-aos="fade-up" data-aos-duration="1000">
              <div className="col-12">
                <p className="icon-heading">
                  Debit , Credit &amp; International Cards
                </p>
                <div className="dv-logos dv-cards">
                  <img
                    alt="logo"
                    className="img-fluid"
                    src={require("assets/img/logos/visa.png")}
                  />
                  <img
                    alt="logo"
                    className="img-fluid"
                    src={require("assets/img/logos/master-card.png")}
                  />
                  <img
                    alt="logo"
                    className="img-fluid"
                    src={require("assets/img/logos/maestro.png")}
                  />
                  <img
                    alt="logo"
                    className="img-fluid"
                    src={require("assets/img/logos/rupay.png")}
                  />
                  <img
                    alt="logo"
                    className="img-fluid"
                    src={require("assets/img/logos/american-express.png")}
                  />
                  <img
                    alt="safexpay-img"
                    className="img-fluid"
                    src={require("assets/img/logos/paypal.png")}
                  />
                </div>
              </div>
            </div>

            <div className="row" data-aos="fade-up" data-aos-duration="1000">
              <div className="col-12">
                <p className="icon-heading">50+ Netbanking Options</p>
                <div className="dv-logos dv-NetBanking">
                  <img
                    alt="logo"
                    className="img-fluid"
                    src={require("assets/img/logos/sbi.png")}
                  />
                  <img
                    alt="logo"
                    className="img-fluid"
                    src={require("assets/img/logos/hdfc.png")}
                  />
                  <img
                    alt="logo"
                    className="img-fluid"
                    src={require("assets/img/logos/icici.png")}
                  />
                  <img
                    alt="logo"
                    className="img-fluid"
                    src={require("assets/img/logos/axis.png")}
                  />
                  <img
                    alt="logo"
                    className="img-fluid"
                    src={require("assets/img/logos/kotak.png")}
                  />
                  <img
                    alt="logo"
                    className="img-fluid"
                    src={require("assets/img/logos/yes.png")}
                  />
                  <img
                    alt="logo"
                    className="img-fluid"
                    src={require("assets/img/logos/bob.png")}
                  />
                </div>
              </div>
            </div>

            <div className="row" data-aos="fade-up" data-aos-duration="1000">
              <div className="col-12">
                <p className="icon-heading">UPI</p>
                <div className="dv-logos dv-upi">
                  <img
                    alt="logo"
                    className="img-fluid"
                    src={require("assets/img/logos/upi.png")}
                  />
                  <img
                    alt="logo"
                    className="img-fluid"
                    src={require("assets/img/logos/bhim.png")}
                  />
                  <img
                    alt="logo"
                    className="img-fluid"
                    src={require("assets/img/logos/g-pay.png")}
                  />
                  <img
                    alt="logo"
                    className="img-fluid"
                    src={require("assets/img/logos/phone-pe.png")}
                  />
                  <img
                    alt="logo"
                    className="img-fluid"
                    src={require("assets/img/logos/bhim-sbi.png")}
                  />
                  <img
                    alt="logo"
                    className="img-fluid"
                    src={require("assets/img/logos/upi-icici.png")}
                  />
                </div>
              </div>
            </div>

            <div className="row" data-aos="fade-up" data-aos-duration="1000">
              <div className="col-12">
                <p className="icon-heading">Wallets &amp; Pay Later</p>
                <div className="dv-logos dv-wallets">
                  <img
                    alt="safexpay-img"
                    className="img-fluid"
                    src={require("assets/img/logos/amazon-pay.png")}
                  />
                  <img
                    alt="safexpay-img"
                    className="img-fluid"
                    src={require("assets/img/logos/paytm.png")}
                  />
                  <img
                    alt="safexpay-img"
                    className="img-fluid"
                    src={require("assets/img/logos/mobikwik.png")}
                  />
                  <img
                    alt="safexpay-img"
                    className="img-fluid"
                    src={require("assets/img/logos/airtel-money.png")}
                  />
                  <img
                    alt="safexpay-img"
                    className="img-fluid"
                    src={require("assets/img/logos/freecharge.png")}
                  />
                  <img
                    alt="safexpay-img"
                    className="img-fluid"
                    src={require("assets/img/logos/lazypay.png")}
                  />
                  <img
                    alt="safexpay-img"
                    className="img-fluid"
                    src={require("assets/img/logos/simpl.png")}
                  />
                  <img
                    alt="safexpay-img"
                    className="img-fluid"
                    src={require("assets/img/logos/jio-money.png")}
                  />
                  <img
                    alt="safexpay-img"
                    className="img-fluid"
                    src={require("assets/img/logos/ola-money.png")}
                  />
                  <img
                    alt="safexpay-img"
                    className="img-fluid"
                    src={require("assets/img/logos/oxigen.png")}
                  />
                  <img
                    alt="safexpay-img"
                    className="img-fluid"
                    src={require("assets/img/logos/epaylater.png")}
                  />
                </div>
              </div>
            </div>

            <div className="row" data-aos="fade-up" data-aos-duration="1000">
              <div className="col-12">
                <p className="icon-heading"></p>
                <div className="dv-logos dv-icons">
                  <div className="icons">
                    <img
                      alt="safexpay-img"
                      className="img-fluid"
                      src={require("assets/img/icons/currencies.png")}
                    />
                    <label className="lbl">50+ Currencies</label>
                  </div>
                  <div className="icons">
                    <img
                      alt="safexpay-img"
                      className="img-fluid"
                      src={require("assets/img/icons/emi.png")}
                    />
                    <label className="lbl">
                      EMI
                      <span>(Cards &amp; Cardless)</span>
                    </label>
                  </div>
                  <div className="icons">
                    <img
                      alt="safexpay-img"
                      className="img-fluid"
                      src={require("assets/img/icons/bharat-qr.png")}
                    />
                    <label className="lbl">Bharat QR</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default PaymentMethods;
